if (!customElements.get('vy-cart-reviews')) {
  customElements.define('vy-cart-reviews', class extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-review-dot]');
        if (dot) this.show(Number(dot.dataset.reviewDot));
        if (event.target.closest('[data-review-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-review-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-review-pause]')) { this.paused = !this.paused; this.syncPause(); }
      }, options);
      this.show(0);
      this.syncPause();
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && (!this.closest('dialog') || this.closest('dialog').open) && !this.matches(':hover') && !this.contains(document.activeElement)) this.show(this.index + 1);
      }, 6500);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    show(index) {
      const slides = this.querySelectorAll('.vy-cart-review');
      if (!slides.length) return;
      this.index = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      const position = this.querySelector('[data-review-position]');
      if (position) position.textContent = `${this.index + 1} / ${slides.length}`;
      this.querySelectorAll('[data-review-dot]').forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
    syncPause() {
      const button = this.querySelector('[data-review-pause]');
      if (!button) return;
      button.textContent = this.paused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', this.paused ? 'Play automatic reviews' : 'Pause automatic reviews');
    }
  });
}
